import { Container, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { RouteService } from '../../../services/RouteService';
import { ITranslateStore } from '../../../stores/TranslateStore';
import NoticeWithButton from '../../common/NoticeWithButton';

interface IDirectPaymentUnsuccessfulProps {
  translateStore?: ITranslateStore;
  routeService?: RouteService;
}

@inject('translateStore', 'routeService')
@observer
export default class DirectPaymentUnsuccessful extends React.Component<IDirectPaymentUnsuccessfulProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    return (
      <Container>
        <Text>
          <NoticeWithButton
            gaEvent="direct-payment-unsuccessful"
            noticeType="error"
            noticeText={translate('invoices.notices.payment-unsuccessful-notice')}
            buttonProps={{
              id: 'direct-payment-return-unsuccessful-notice-button',
              iconRight: '#arrow-right',
              text: translate('shared.notices.login-required.login-button'),
              onClick: () => this.props.routeService.navigateToInvoicePage()
            }}
          />
        </Text>
      </Container>
    );
  }
}
